import { Typeahead, type TypeaheadProps } from '@fv/client-components/combobox'

type Props<T> = Pick<
  TypeaheadProps<T>,
  | 'name'
  | 'isClearable'
  | 'required'
  | 'readOnly'
  | 'disabled'
  | 'placeholder'
  | 'autoFocus'
  | 'emptyMessage'
  | 'isLoading'
  | 'ref'
  | 'options'
  | 'value'
  | 'getOptionLabel'
  | 'getOptionValue'
  | 'renderOption'
  | 'filter'
> & {
  onChange?: (value: T | null) => void
  onSearchChange?: (value: string) => void
}

export function AdminTypeaheadField<T>({
  onChange,
  onSearchChange,
  getOptionLabel = (o: T) => String((o as Record<string, unknown>).name ?? o),
  ...rest
}: Props<T>) {
  return (
    <div className="w-full">
      <Typeahead
        onSelect={onChange}
        onInputValueChange={onSearchChange}
        getOptionLabel={getOptionLabel}
        classNames={{
          root: 'relative',
          input: 'input w-full',
          clear:
            'absolute right-2 top-1/2 -translate-y-1/2 text-base-content opacity-50 hover:opacity-100',
          positioner:
            'border border-base-content/50 shadow-md mt-1 bg-base-100 text-base-content z-[9999]',
          list: 'max-h-60 overflow-y-auto',
          option:
            'border-b border-b-base-content border-b-opacity-50 p-2 hover:bg-secondary/20 data-[highlighted]:bg-secondary/20 cursor-pointer',
          empty: 'border-b p-2 text-base-content opacity-60',
          loading: 'p-2 text-base-content opacity-60',
        }}
        {...rest}
      />
    </div>
  )
}
